$('.js-reviewSlider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: '<div type="button" class="slick-next"><svg><use xlink:href="#icon-arrow-right"></use></svg></div>',
    prevArrow: '<div type="button" class="slick-prev"><svg><use xlink:href="#icon-arrow-right"></use></svg></div>',
    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
    ]
});